"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils/utils");
// Packages

// Utils

// Styles
const {
  below
} = (0, _utils.getMediaQueries)({
  ..._utils.mediaBreakpoints,
  mobile: 620
});
const Nav = _styledComponents.default.nav.withConfig({
  displayName: "newsroom-nav__Nav",
  componentId: "sc-cz2oe7-0"
})(["background-color:", ";display:flex;min-height:64px;max-height:64px;overflow:hidden;"], props => props.navBackgroundColor || "#031d30");
const NavItemsList = _styledComponents.default.ul.withConfig({
  displayName: "newsroom-nav__NavItemsList",
  componentId: "sc-cz2oe7-1"
})(["display:flex;max-width:656px;width:100%;margin:0 auto;padding:0 48px;align-items:center;justify-content:space-evenly;color:white;line-height:64px;", " li,li::before{all:unset;}li a{position:relative;padding:0 8px;font-size:16px;color:", ";display:block;transition:0.3s ease-in-out;text-decoration:none;", " ::before{content:\"\";position:absolute;width:100%;height:4px;bottom:0;left:0;background-color:", ";visibility:hidden;transform:scaleX(0);transition:0.3s ease-in-out;}:hover{::before{visibility:visible;transform:scaleX(1);}}&.active{::before{visibility:visible;transform:scaleX(1);}}}span{color:", ";", "}"], below.mobile`padding: 0 24px;`, props => props.linkColor || "white", below.mobile`padding: 0 6px; letter-spacing: -.2px;`, props => props.activeLinkBordercolor || "var(--horizon-yellow-hex)", props => props.linkColor || "white", below.mobile`display: none;`);
const NewsroomNav = props => {
  return /*#__PURE__*/_react.default.createElement(Nav, {
    navBackgroundColor: props.navBackgroundColor
  }, /*#__PURE__*/_react.default.createElement(NavItemsList, {
    linkColor: props.linkColor,
    activeLinkBorderColor: props.activeLinkBorderColor
  }, props.navItems && props.navItems.map((item, i) => {
    return item;
  })));
};
NewsroomNav.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NewsroomNav"
};
var _default = NewsroomNav;
exports.default = _default;